import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { getCookie } from '_lib/utils/utils'
import { STABLE_ANIMATION_CLASS_NAME } from "_lib/constants/global"
import { NO_PERMISSION_TYPE, NO_PERMISSION_TEXT } from '_lib/constants/no-permission'
import './assets/css/tailwind.css'
import './assets/css/theme.scss'
import './assets/font/iconfont.css'
import './assets/font/font.css'

import './assets/css/common.scss'
import './assets/css/toast.scss'
import './assets/css/rich_text_user_list.scss'
import './assets/css/cropper.scss'
import './assets/css/setting.scss'

import RTC from "./common/RtcApi/standard"
import shortcut from "./common/shortcutDeliver"
import permission from './common/permission'
import unread from './common/unreadState'
import timingCollectorInstance from './common/TimingCollector'

import { eventDelegationDirective } from './directives/eventDelegationDirective'
Vue.directive('delegate', eventDelegationDirective);
import { remind2LoginDirective } from './directives/Remind2LoginDirective'
Vue.directive('remind-to-login', remind2LoginDirective);
import { emojiHtmlDirective } from './directives/emojiHtmlDirective.js'
Vue.directive('emoji-html', emojiHtmlDirective);
import { tooltipDirective } from './directives/tooltipDirective.js';
Vue.directive('tooltip', tooltipDirective);

if (!process.env.IS_CLIENT) {
  import('./directives/hb-open-app/index').then(({ OpenAppPlugin }) => {
    Vue.use(OpenAppPlugin, {
      options: {},
      protocol: {}
    });
  });
}

import { imgObserverRegistry } from './ChatUI/utils/img-lazy-load'

import './assets/js/sm.js'
imgObserverRegistry()


import { 
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Dialog,
  Switch,
  Loading,
  Select,
  Option,
  OptionGroup,
  Popover,
  Button,
  Image,
  DatePicker,
  TimePicker,
  TimeSelect,
  TabPane,
  Tabs,
  Cascader,
  CascaderPanel,
  Pagination,
  Carousel, 
  CarouselItem
} from 'element-ui'

Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(Dialog)
Vue.use(Switch)
Vue.use(Loading)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Popover)
Vue.use(Button)
Vue.use(Image)
Vue.use(DatePicker)
Vue.use(TimePicker);
Vue.use(TimeSelect)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Cascader)
Vue.use(CascaderPanel)
Vue.use(Pagination)
Vue.use(Carousel)
Vue.use(CarouselItem)
import './assets/css/reset.scss'


import ChatUI from "./ChatUI/src/index.js";
Vue.use(ChatUI)

import ExposurePlugin from './common/Exposure'
Vue.use(ExposurePlugin)

import HeyboxReport from './common/heybox-report'
Vue.use(HeyboxReport)

let userOps = []
let userOpTimer = null
window.needReportUserOp = false

Vue.prototype.$userop = (op) => {
  if (!op) {
    return
  }
  if (process.env.IS_PROD && process.env.IS_CLIENT) {
    userOps.push(op)
    if (window.needReportUserOp) {
      clearTimeout(userOpTimer)
      userOpTimer = setTimeout(() => {
        window.electronAPI.userOpReport(userOps)
        userOps.length = 0
      }, 1000)
    }
  }
}

Vue.prototype.$protocol = (...args) => {
  import('_lib/protocol').then((Protocol) => {
    Vue.use(Protocol.default)
    Vue.prototype.$protocol(...args)
  })
}
Vue.prototype.$contextmenu = (...args) => {
  import('_lib/ContextMenu/index').then((ContextMenu) => {
    Vue.use(ContextMenu.default)
    Vue.prototype.$contextmenu(...args)
  })
}
Vue.prototype.$contextmenu.destroy = () => {}
Vue.prototype.$query = (...args) => {
  import('_lib/QueryDialog/index').then((QueryDialog) => {
    Vue.use(QueryDialog.default)
    Vue.prototype.$query(...args)
  })
}

Vue.prototype.$rtc = new RTC()
Vue.prototype.$shortcut = shortcut
Vue.prototype.$permission = permission
Vue.prototype.$unread = unread
Vue.prototype.isClient = process.env.IS_CLIENT
Vue.prototype.STABLE_ANIMATION_CLASS_NAME = STABLE_ANIMATION_CLASS_NAME

// 添加类型定义
interface ToastOptions {
  icon?: string;
  [key: string]: any;
}

// 替换当前的toast初始化逻辑
let toastLoaded = false
let toastQueue: {content: any, type: string, options?: ToastOptions}[] = []

// 初始化函数，所有toast方法调用时都会触发
const initToast = (content: any, type: string, options?: ToastOptions) => {
  if (toastLoaded) return
  console.log('initToast')
  
  // 先将当前调用放入队列
  toastQueue.push({content, type, options})
  
  // 同时加载JS和CSS
  Promise.all([
    import("vue-toastification"),
    import("vue-toastification/dist/index.css")
  ]).then(([Toast]) => {
    Vue.use(Toast.default, {
      draggable: false,
      pauseOnFocusLoss: false,
      pauseOnHover: false,
      timeout: 2000,
      hideProgressBar: true,
      closeButton: false,
      position: 'top-center',
      transition: "toast-transition",
    })
    
    // 标记已加载
    toastLoaded = true
    
    // 处理默认图标
    const originalError = Vue.prototype.$toast.error
    Vue.prototype.$toast.error = (content: any, opts?: ToastOptions) => {
      return originalError(content, {...opts, icon: 'iconfont icon-toast-warn'})
    }
    
    const originalWarning = Vue.prototype.$toast.warning
    Vue.prototype.$toast.warning = (content: any, opts?: ToastOptions) => {
      return originalWarning(content, {...opts, icon: 'iconfont icon-report'})
    }
    
    // 添加no_permission方法
    Vue.prototype.$toast.no_permission = (type: keyof typeof NO_PERMISSION_TYPE) => {
      return Vue.prototype.$toast.error(NO_PERMISSION_TEXT[type])
    }
    
    // 处理队列中的toast
    while (toastQueue.length > 0) {
      const {content, type, options} = toastQueue.shift()
      if (type) {
        Vue.prototype.$toast[type](content, options)
      } else {
        Vue.prototype.$toast(content, options)
      }
    }
  })
  
  return null
}

// 所有toast方法初始都指向initToast
Vue.prototype.$toast = initToast as any
Vue.prototype.$toast.success = (content: any, options?: ToastOptions) => initToast(content, 'success', options)
Vue.prototype.$toast.error = (content: any, options?: ToastOptions) => initToast(content, 'error', options)
Vue.prototype.$toast.info = (content: any, options?: ToastOptions) => initToast(content, 'info', options)
Vue.prototype.$toast.warning = (content: any, options?: ToastOptions) => initToast(content, 'warning', options)
Vue.prototype.$toast.no_permission = (type: keyof typeof NO_PERMISSION_TYPE) => {
  return initToast(NO_PERMISSION_TEXT[type], 'error')
}

Vue.config.productionTip = false

if (process.env.IS_PROD && process.env.IS_CLIENT) {
  window.onerror = (message, source, lineno, colno, error) => {
    window.electronAPI.sentryReport(message, error.stack)
  }
  
  Vue.config.errorHandler = (error) => {
    window.electronAPI.sentryReport(error.message, error.stack)
  }

  window.addEventListener('unhandledrejection', (event) => {
    let errorMessage = `Unhandled rejection: ${event.reason}`;
    let errorStack = null;
  
    if (event.reason instanceof Error) {
      errorStack = event.reason.stack;
    } else {
      // 如果 reason 不是 Error 对象，可以手动创建一个 Error 对象
      let error = new Error(errorMessage);
      errorStack = error.stack;
    }
    window.electronAPI.sentryReport(errorMessage, errorStack);
  })
}

// 非客户端，声明log函数
if (!window.clientLog) {
  window.clientLog = (...args) => console.log(...args)
}

window.internal_version = process.env.INTERNAL_VERSION

window.timing_collector = timingCollectorInstance;

// window.__protocol = (url: string, info: any) => {
//   Vue.prototype.$protocol(url, info)
// }

const app = new Vue({
  router,
  store,
  render: h => h(App)
})
app.$mount('#app')